import type { BaseOptionType } from 'antd/es/select';

export const statusOptions: BaseOptionType[] = [
  {
    label: <span>Действующие</span>,
    value: 'active',
    filterName: 'Действующие',
  },
  {
    label: <span>В архиве</span>,
    value: 'archived',
    filterName: 'В архиве',
  },
];
